module.exports = __webpack_public_path__ + "img/Bolsa Carryall 35.900caf0f.jpg";